/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="position-relative">
    <label v-show="label" :for="_uid + '_' + name" class="absolute-label">{{label}}</label>
    <b-form-input
      :id="_uid + '_' + name"
      v-model="valueComputed"
      :class="[classInput, {'empty' : !valueComputed.length }]"
      :type="newType"
      :name="name"
      :min="min"
      :max="max"
      :state="validState"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :autofocus="autofocus"
      :ref="name"
      :required="required"
      :disabled="disabled"
      :readonly="readonly"
      :data-vv-scope="dataVvScope"
      spellcheck="false"
      @change="$emit('change', $event)"
      @blur.native="$emit('blur')"
      >
    </b-form-input>
    <div class="password-visibility" v-if="type === 'password'" @click.prevent="switchVisibility">
      <svg class="o-icon" v-show="newType === 'password'"><use xlink:href="#eye-hidden"></use></svg>
      <svg class="o-icon" v-show="newType === 'text'"><use xlink:href="#eye-visible"></use></svg>
    </div>
    <b-form-invalid-feedback >
      <!-- This will only be shown if the preceeding input has an invalid state -->
      <div v-for="(validation, index) in validationsFiltered"
        :key="index">
        {{ validation.text }}
      </div>
    </b-form-invalid-feedback>
    <b-form-text v-if="info">
      <!-- this is a form text block (formerly known as help block) -->
      {{ info }}
    </b-form-text>
  </div>
</template>

<script>
import filter from 'lodash/filter'

export default {
  name: 'BaseInput',
  props: {
    classInput: {
      type: [Array, Object, String]
    },
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, null],
      required: true
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    info: {
      type: String,
      required: false,
      default: ''
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    },
    dataVvScope: {
      type: String
    },
    showHidePass: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String
    },
    min: {
      type: String
    },
    max: {
      type: String
    }
  },
  data () {
    return {
      newType: this.type
    }
  },
  computed: {
    valueComputed: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    validState () {
      let state = null
      for (let validation of this.validations) {
        if (validation.condition) {
          state = false
          break
        }
      }
      return state
    },
    validationsFiltered () {
      return filter(this.validations, { condition: true })
    }
  },
  methods: {
    changeTypeOfInput () {
      this.newType = this.newType === 'password' ? 'text' : 'password'
    },
    eventEmitter (evt, payload) {
      this.$emit('input', payload)
    },
    switchVisibility () {
      if (this.newType === 'password') {
        this.newType = 'text'
      } else {
        this.newType = 'password'
      }
    }
  }
}
</script>
